/* test */

/* Custom JS for CPB App
 * Author: Geoff Jackson
 * Company: All Jigsaw Puzzles
 * Email: geoff@alljigsawpuzzles.co.uk
 */
const updatePersonalizeBtnMarkup = () => {
  const btn = document.querySelector('.personalize-it--js');
  const span = document.createElement('span');
  span.classList.add('personalize-it--js__inner-text');
  span.textContent = btn.textContent;
  span.addEventListener('click', () => btn.click());
  btn.removeChild(btn.childNodes[0]);
  btn.append(span);
};

addEventListener("DOMContentLoaded", (event) => {
  updatePersonalizeBtnMarkup();
});

/* Testing this file is loading */
//console.log("🧩 Custom Product Builder: Custom JS loaded and running");

//const testBadge = document.createElement('div');
//testBadge.textContent = "✅ CPB Custom JS is active";
//testBadge.style.position = 'fixed';
//testBadge.style.bottom = '100px';
//testBadge.style.right = '20px';
//testBadge.style.padding = '10px';
//testBadge.style.background = '#1e88e5';
//testBadge.style.color = 'white';
//testBadge.style.zIndex = '9999';
//testBadge.style.fontSize = '14px';
//document.body.appendChild(testBadge);

/* Script to map Shopify variant selection to size option in CPB */
document.addEventListener("DOMContentLoaded", () => {
  if (window.CPBScriptLoaded) return;
  window.CPBScriptLoaded = true;

  // console.log("🚀 Script loaded");

  let selectedSize = null;

  function getSelectedSizeVariant() {
    const selectedInput = document.querySelector('input[name="Size"]:checked');
    if (selectedInput) {
      selectedSize = selectedInput.value.trim();
      // console.log("✅ Selected Shopify variant (Size):", selectedSize);
    } else {
      // console.warn("⚠️ No selected size input found");
    }
  }

  function setAppSizeSelection() {
    console.log("👋 setAppSizeSelection() triggered — selectedSize:", selectedSize);
    // console.log("🔍 Looking for app size options...");
    if (!selectedSize) {
      // console.warn("❌ No size was selected before launching app");
      return;
    }

    const sizeOptions = document.querySelectorAll('.cpb-size-variants .cpb-option');
    // console.log(`🔍 Found ${sizeOptions.length} size options in .cpb-size-variants`);

    const normalize = str => str.toLowerCase().replace(/\s+/g, '').replace(/[^a-z0-9]/gi, '');

    const activeOption = document.querySelector('.cpb-size-variants .cpb-option.cpb-active');
    // console.log("📌 CPB says this is currently selected:", activeOption?.textContent.trim());

    let matched = false;

    sizeOptions.forEach(option => {
      const label = option.querySelector('div')?.textContent?.trim() ?? '';
      // console.log(`   • Comparing "${label}" vs "${selectedSize}"`);

      if (normalize(label) === normalize(selectedSize)) {
        // console.log(`🎯 Forcing click to select: ${label}`);
        option.click();
        matched = true;
      }
    });

    if (matched) {
      console.log("✅ Shopify variant mapped to CPB successfully");
    } else {
      // console.warn(`⚠️ No matching CPB size option found for "${selectedSize}"`);
    }
  }

  // Forcefully remove .cpb-collapsed from preview on app launch (with retries)
  const forceUncollapse = (retries = 10) => {
    const preview = document.querySelector('.cpb-preview-container');
    if (!preview) return setTimeout(() => forceUncollapse(retries), 200);
  
    if (preview.classList.contains('cpb-collapsed')) {
      preview.classList.remove('cpb-collapsed');
      console.log("🧼 Forced removal of .cpb-collapsed");
    }
  
    // Retry in case CPB tries to re-add it
    if (retries > 0) {
      setTimeout(() => forceUncollapse(retries - 1), 300);
    }
  };

  // 👀 Keep .cpb-preview-container uncollapsed after CPB loads
  const previewContainer = document.querySelector('.cpb-preview-container');
  if (previewContainer) {
    const collapseObserver = new MutationObserver(() => {
      if (previewContainer.classList.contains('cpb-collapsed')) {
        previewContainer.classList.remove('cpb-collapsed');
        console.log("🚫 Auto-removed .cpb-collapsed via observer");
      }
    });
  
    collapseObserver.observe(previewContainer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  const personalizeButton = document.querySelector('.personalize-it--js');
  
  if (personalizeButton) {
    personalizeButton.addEventListener(
      'click',
      () => {
        getSelectedSizeVariant();
  
        const interval = setInterval(() => {
          const cpbContainer = document.querySelector('.cpb-size-variants');
          const options = cpbContainer?.querySelectorAll('.cpb-option') ?? [];
  
          if (cpbContainer && options.length > 0) {
            clearInterval(interval);
            setAppSizeSelection();
  
            const preview = document.querySelector('.cpb-preview-container');
            if (preview) {
              // ✅ Ensure preview is visible on initial load
              preview.classList.remove('cpb-collapsed');
              console.log("🧼 Removed .cpb-collapsed on initial load to show image");
            }
  
            const scrollToPreviewTop = () => {
              const preview = document.querySelector('.cpb-preview-container');
              if (!preview) return;
            
              const scrollWhenReady = () => {
                // Remove collapsed class before checking visibility
                preview.classList.remove('cpb-collapsed');
            
                const rect = preview.getBoundingClientRect();
                const visible = rect.height > 0 && rect.top !== 0;
            
                if (visible) {
                  preview.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  console.log("🎯 Scrolled to CPB preview top");
                } else {
                  console.log("⏳ Waiting for preview visibility...");
                  setTimeout(scrollWhenReady, 250);
                }
              };
            
              scrollWhenReady();
            };
            
            setTimeout(scrollToPreviewTop, 500);
          }
        }, 250);
      },
      { once: true }
    );
  }
});

// Moves native agreements checkbox for terms and conditions to the bottom of our step 2 (customer photo upload) otherwise is placed after step 3
/*document.addEventListener("DOMContentLoaded", () => {
  const waitForCPBAgreement = setInterval(() => {
    const agreement = document.querySelector('.cpb-agreement-wrapper');
    const step2 = document.querySelector('.cpb-ajp-step.cpb-step-2');

    if (agreement && step2) {
      // Move agreement to bottom of step 2
      step2.appendChild(agreement);
      clearInterval(waitForCPBAgreement);
      console.log("✅ Moved agreement to step 2");
    }
  }, 250);
});*/

document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    const fileInput = document.querySelector('.cpb-drop-zone input[type="file"]');
    const nextBtn = document.querySelector('.cpb-ajp-step.cpb-step-2 .cpb-category-next-step-btn');
    const agreementWrapper = document.querySelector('.cpb-agreement-wrapper');
    const step2 = document.querySelector('.cpb-ajp-step.cpb-step-2');

    if (fileInput && agreementWrapper && step2) {
      observer.disconnect();
      console.log("✅ Step 1 triggered — setup starting...");

      // Hide original agreement and clone to bottom of step 2
      if (!step2.querySelector('.cpb-agreement-wrapper.clone')) {
        const clonedAgreement = agreementWrapper.cloneNode(true);
        clonedAgreement.classList.add('clone');
        step2.appendChild(clonedAgreement);
        agreementWrapper.style.display = "none";

        // Sync checkbox states
        const originalCheckbox = agreementWrapper.querySelector('input[type="checkbox"]');
        const clonedCheckbox = clonedAgreement.querySelector('input[type="checkbox"]');

        if (originalCheckbox && clonedCheckbox) {
          clonedCheckbox.addEventListener("change", () => {
            originalCheckbox.checked = clonedCheckbox.checked;

            // Simulate full change events
            originalCheckbox.dispatchEvent(new MouseEvent("click", { bubbles: true }));
            originalCheckbox.dispatchEvent(new Event("change", { bubbles: true }));
          });
        }

        // If nextBtn exists, move it under the cloned agreement
        if (nextBtn) {
          nextBtn.style.setProperty("display", "block", "important");
          nextBtn.removeAttribute("disabled");
          nextBtn.classList.remove("disabled");
          clonedAgreement.appendChild(nextBtn);

          // Update button text
          const labelSpan = nextBtn.querySelector('.cpb-string-template');
          if (labelSpan) labelSpan.textContent = "Proceed";
        }
      }

      // Step 2: Watch for .cpb-upload-image appearing
      const imageContainerObserver = new MutationObserver(() => {
        const uploadImageContainer = document.querySelector('.cpb-upload-image');
        if (!uploadImageContainer) return;

        console.log("📦 Found .cpb-upload-image — observing for preview image...");
        imageContainerObserver.disconnect();

        function validateUploadedImage(retries = 10) {
          const images = Array.from(uploadImageContainer.querySelectorAll('img'));
          const validImg = images.find(img =>
            img.src &&
            !img.src.toLowerCase().includes('.gif') &&
            img.naturalWidth > 1 &&
            img.naturalHeight > 1
          );

          if (!validImg) {
            if (retries > 0) {
              console.log(`⏳ Waiting for valid image... (${retries} retries left)`);
              setTimeout(() => validateUploadedImage(retries - 1), 300);
            } else {
              console.warn("❌ No valid image found");
            }
            return;
          }

          console.log(`✅ Image validated (${validImg.naturalWidth}×${validImg.naturalHeight})`);
          const dimensions = `${validImg.naturalWidth}×${validImg.naturalHeight}px`;

          // Feedback message
          const messageId = "cpb-upload-feedback";
          document.getElementById(messageId)?.remove();

          const message = document.createElement("div");
          message.id = messageId;
          message.classList.add("cpb-upload-feedback");

          if (validImg.naturalWidth < 1500 || validImg.naturalHeight < 1500) {
            message.classList.add("warning");
            message.innerHTML = `⚠️ <strong>We recommend images of at least 1500×1500px.</strong> Your image is <strong>${dimensions}</strong>.`;
          } else {
            message.classList.add("success");
            message.innerHTML = `✅ <strong>Your image meets the recommended size.</strong> (${dimensions})`;
          }

          // Append message inside cloned agreement
          const clonedAgreement = step2.querySelector('.cpb-agreement-wrapper.clone');
          if (clonedAgreement) {
            clonedAgreement.insertBefore(message, clonedAgreement.firstChild);
          }

          // Re-enable next button if it exists
          if (nextBtn) {
            nextBtn.style.setProperty("display", "flex", "important");
            nextBtn.removeAttribute("disabled");
            nextBtn.classList.remove("disabled");
          }
        }

        const imgNow = uploadImageContainer.querySelector('img');
        if (imgNow) {
          console.log("⚡ Image found immediately — validating...");
          validateUploadedImage();
        }

        const uploadObserver = new MutationObserver(() => {
          const uploadedImg = uploadImageContainer.querySelector('img');
          if (uploadedImg) {
            console.log("📸 Detected image upload — validating...");
            validateUploadedImage();
          }
        });

        uploadObserver.observe(uploadImageContainer, { childList: true, subtree: true });
      });

      imageContainerObserver.observe(document.body, { childList: true, subtree: true });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// Add class to style the most popular size variant (1000pc)
const markPopularOption = () => {
  document.querySelectorAll('.cpb-option').forEach(option => {
    const text = option.textContent.trim();
    if (text === '1000pc') {
      option.classList.add('cpb-popular');
      console.log("🏷️ Marked 1000pc option as .cpb-popular");
    }
  });
};

// Observe DOM for when options are injected
const optionObserver = new MutationObserver(() => {
  const optionsExist = document.querySelectorAll('.cpb-option').length > 0;
  const alreadyTagged = document.querySelector('.cpb-popular');

  if (optionsExist && !alreadyTagged) {
    markPopularOption();
  }
});

optionObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Change the default 'Add to Cart' button label to 'Add to basket' so it matches rest of the website
document.addEventListener("DOMContentLoaded", () => {
  const updateCPBButtonLabel = () => {
    const cpbButton = document.querySelector(".cpb-add-to-cart-button span");
    if (cpbButton && cpbButton.textContent.trim() === "Add to Cart") {
      cpbButton.textContent = "Add to basket";
    }
  };

  // Run immediately in case the element is already present
  updateCPBButtonLabel();

  // Observe changes in the DOM in case CPB injects the button later
  const observer = new MutationObserver(() => {
    updateCPBButtonLabel();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

function buildModalOverlay() {
  if (document.getElementById('cpb-preview-modal-overlay')) {
    console.log("🧼 Overlay already exists — skipping creation");
    return;
  }
  const overlay = document.createElement('div');
  overlay.id = 'cpb-preview-modal-overlay';
  overlay.style.cssText = `
    display: none;
  `;

  // Move the overlay directly after the preview container in DOM
  const preview = document.querySelector('.cpb-preview-container');

  //document.body.appendChild(overlay);
  // switch to the below to insert the overlay adjacent to .cpb-preview-container
  if (preview && preview.parentNode) {
    preview.parentNode.insertBefore(overlay, preview.nextSibling);
  } else {
    document.body.appendChild(overlay); // fallback
  }

  console.log("📦 Overlay inserted next to preview");
}

const waitForBuilder = setInterval(() => {
  const builder = document.getElementById('product-builder');
  const preview = document.querySelector('.cpb-preview-container');
  const isMobile = window.innerWidth <= 768;

  const originalPreviewWrapper = preview?.parentElement;
  const originalNextSibling = preview?.nextElementSibling;

  if (!builder || !preview || !isMobile) return;

  clearInterval(waitForBuilder);
  console.log("🧩 Expand script ready");

  buildModalOverlay();

  // Create expand preview bubble
  const expandBtn = document.createElement('div');
  expandBtn.id = 'cpb-preview-expand-btn';
  expandBtn.textContent = '🔍 Preview';
  expandBtn.style.display = 'none';

  /*document.body.appendChild(expandBtn);
  const previewBottom = preview.getBoundingClientRect().bottom;
  const isFixed = builder.classList.contains('cpb-fix-image') || builder.classList.contains('cpb-fix-image-landscape');
  
  if (previewBottom <= 0 && isFixed) {
    expandBtn.style.display = 'block';
  } else {
    expandBtn.style.display = 'none';
  }*/

  document.body.appendChild(expandBtn);

  window.addEventListener('scroll', () => {
    const preview = document.querySelector('.cpb-preview-container');
    const builder = document.getElementById('product-builder');
    const expandBtn = document.getElementById('cpb-preview-expand-btn');
  
    if (!preview || !builder || !expandBtn) return;
  
    //const previewBottom = preview.getBoundingClientRect().bottom;
    //const rect = preview.getBoundingClientRect();
    //const previewMid = rect.top + (rect.height / 2);
    previewTop = preview.getBoundingClientRect().top;
    const isFixed = builder.classList.contains('cpb-fix-image') || builder.classList.contains('cpb-fix-image-landscape');
  
    if (previewTop <= 0 && isFixed) {
      expandBtn.style.display = 'block';
    } else {
      expandBtn.style.display = 'none';
    }
  });

  /*
  const tryAppendExpandButton = setInterval(() => {
    const layout = document.querySelector('.cpb-layout');
    if (layout && !document.getElementById('cpb-preview-expand-btn')) {
      layout.appendChild(expandBtn);
      clearInterval(tryAppendExpandButton);
      console.log("📎 Expand button added inside .cpb-layout");

      window.addEventListener('scroll', () => {
        const preview = document.querySelector('.cpb-preview-container');
        const builder = document.getElementById('product-builder');
        if (!preview || !builder) return;
        
        const previewBottom = preview.getBoundingClientRect().bottom + window.scrollY;
        const scrollY = window.scrollY;
        const isFixed = builder.classList.contains('cpb-fix-image') || builder.classList.contains('cpb-fix-image-landscape');
        
        const passedPreview = scrollY > previewTop;

        if (scrollY > previewBottom && isFixed) {
          expandBtn.style.display = 'block';
        } else {
          expandBtn.style.display = 'none';
        }

        const previewBottom = preview.getBoundingClientRect().bottom;
        const isFixed = builder.classList.contains('cpb-fix-image') || builder.classList.contains('cpb-fix-image-landscape');
        
        if (previewBottom <= 0 && isFixed) {
          expandBtn.style.display = 'block';
        } else {
          expandBtn.style.display = 'none';
        }
        
        if (passedPreview && builder.classList.contains('cpb-fix-image')) {
          expandBtn.classList.add('cpb-expand-btn-floating');
        
          // Manually place it near top right of viewport
          const offsetTop = 20; // px from top of screen
          const offsetRight = 20; // px from right of screen
          //expandBtn.style.transform = `translate(${window.innerWidth - offsetRight - expandBtn.offsetWidth}px, ${offsetTop}px)`;
          expandBtn.style.transform = `translate(20px, ${offsetTop}px)`;
          expandBtn.style.position = 'absolute';
          expandBtn.style.zIndex = '2000';
          expandBtn.style.pointerEvents = 'auto'; // in case anything blocks it
        
        } else {
          expandBtn.classList.remove('cpb-expand-btn-floating');
          expandBtn.style.transform = '';
          expandBtn.style.position = '';
          expandBtn.style.zIndex = '';
        }
      });
    }
  }, 100);
  */

  // ✅ Show modal-like zoomed preview
  expandBtn.addEventListener('click', () => {
    const layout = document.querySelector('.cpb-layout');
    const preview = document.querySelector('.cpb-preview-container');
    const overlay = document.getElementById('cpb-preview-modal-overlay');
    
    if (!preview || !overlay) return;

    if (preview) {
      preview.classList.add('cpb-zoomed');
      
      // Force preview container to be appended to body temporarily
      preview.setAttribute('data-original-parent', preview.parentElement?.className || '');
      document.body.appendChild(preview);
    }
    if (layout) {
      layout.classList.add('cpb-zoomed-active');
      document.body.classList.add('cpb-preview-overlay-visible');
      document.body.classList.add('cpb-temp-modal');
    }
    overlay.style.display = 'block';
    expandBtn.style.display = 'none';

    if (!document.getElementById('cpb-preview-close-btn')) {
      const closeBtn = document.createElement('button');
      closeBtn.id = 'cpb-preview-close-btn';
      closeBtn.setAttribute('aria-label', 'Close preview');
      closeBtn.title = 'Close image preview';
      //closeBtn.innerText = '✕';
      closeBtn.className = 'text-gray-500 hover:text-gray-700 focus:outline-none cpb-preview-close-btn';
      closeBtn.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      `;
      closeBtn.classList.add('cpb-preview-close-btn');

      closeBtn.addEventListener('click', () => {
        if (preview) {
          preview.classList.remove('cpb-zoomed');

          // Re-append back to its original location
          const wrapper = document.querySelector('.cpb-layout');
          if (wrapper && !wrapper.contains(preview)) {
            wrapper.insertBefore(preview, wrapper.firstChild);
          }
        }
        if (layout) {
          layout.classList.remove('cpb-zoomed-active');
          document.body.classList.remove('cpb-preview-overlay-visible');
          document.body.classList.remove('cpb-temp-modal');
        }
        overlay.style.display = 'none';
        expandBtn.style.display = 'block';
        closeBtn.remove();
      });

      preview.appendChild(closeBtn);
    }

    console.log("🔍 Expand Preview activated");
  });

  // ✅ Observe CPB shrink state to toggle expand button
  let expandBtnShouldBeVisible = false;
  const observer = new MutationObserver(() => {
    const isCollapsed = builder.classList.contains('cpb-fix-image') ||
                        builder.classList.contains('cpb-fix-image-landscape');
    console.log("📦 Mutation triggered — isCollapsed:", isCollapsed);
    //expandBtn.style.display = isCollapsed ? 'block' : 'none';
    if (isCollapsed) {
      expandBtn.style.display = 'block';
      expandBtnShouldBeVisible = true;
    } else {
      // Only hide if it was never shown before (i.e. initial load)
      if (!expandBtnShouldBeVisible) {
        expandBtn.style.display = 'none';
      }
    }
  });

  observer.observe(builder, { attributes: true, attributeFilter: ['class'] });

}, 300);

function customAddToCart() {
    if (!!window._cpb.settings === false) window._cpb.settings = {}
    window._cpb.settings.addToCartOverride = async data => {

        data.items.forEach(item => {
          const newProperties = {}
          for (let prop in item.properties) {
            if (prop !== 'is_calculated') {
              if (prop === '_image') {
                newProperties.Image = item.properties[prop]
              } else if (typeof item.properties[prop] === 'string' && item.properties[prop].includes('/customers/')) {
                newProperties['_uploaded image'] = item.properties[prop];
              } else {
                newProperties[prop] = item.properties[prop]
              }
            }
          }
          item.properties = {...newProperties}
        })
      
        fetch("/cart/add.js", {
            "headers": {
                "content-type": "application/json;charset=UTF-8"
            },
            "body": JSON.stringify({
                items: data.items
            }),
            "method": "POST"
        }).then(() => {
            if(data.redirect) location.href = '/cart'
        })
    }
}

const blockMovingLayerOnBox = async () => {
  let rightimageData;
  let customCanvasIsMounted = false;

  const api = await CPB.createFrontApi();

  const customCanvas = {
    el: null,
    ctx: null,
    updateImageData(newData) {
      this.ctx.putImageData(newData, 0, 0);
      return this.ell;
    },
    updateSize(width, height) {
      this.el.width = width;
      this.el.height = height;
      return this.ell;
    },
    create(width,height) {
      const element = document.createElement('canvas');
      element.width = width;
      element.height = height;
      element.style.width = '100%';
      element.classList.add('cpbc-custom-layer');

      document.addEventListener('resize', () => {
        this.updateSize(document.querySelector('#product-builder canvas').width, document.querySelector('#product-builder canvas').height);
      });
      this.el = element;
      this.ctx = element.getContext('2d');
      return element;
    }
  }
  
  const getRightImageData = () => {
    const Product = api.State.Product;
    let photoIsUploaded = false;
    
    Product.panels.forEach(p => {
      p.categories.forEach(c => {
        if (c.type !== "fileUpload") return;
        if (!c.options[0].fileUploadValue) return
        photoIsUploaded = true;
      });
    });

    if (!photoIsUploaded) return console.log("photo isn't uploaded");

    const canvas = cpbImageStorage.views.left.getSnapshotCanvas({ canvasSize: document.querySelector('#product-builder canvas').width });
    const ctx = canvas.getContext('2d');
    return ctx.getImageData(0, 0, canvas.width, canvas.height);
  };

  const updateRightImageData = (e) => {
    setTimeout(() => {
      rightimageData = getRightImageData();
      document.body.removeEventListener('CPB_ON_RENDER_LAYERS', updateRightImageData);
      console.log('imageData updated, listener removed');
      customCanvas.updateImageData(rightimageData);
      console.log(e)
    }, 2000);
  }

  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function(event) {
    const newLayers = event.detail.newLayers;
    if (newLayers.length < 1) return;
    if (!newLayers[0].fileUploadData) return;

    if (!customCanvasIsMounted) {
      const photoOnBoxLayer = document.querySelector('.cpb-preview-container .swiper-slide:last-child canvas[data-title*="Photo on Box"]');
      const customLayer = customCanvas.create(photoOnBoxLayer.width, photoOnBoxLayer.height);
      photoOnBoxLayer.insertAdjacentElement('afterend', customLayer);
      customCanvasIsMounted = true
    } else {
      document.querySelector('.cpb-preview-container .swiper-slide:last-child canvas[data-title*="Photo on Box"]').insertAdjacentElement('afterend', customCanvas.el);
    }
    
    document.body.addEventListener('CPB_ON_RENDER_LAYERS', updateRightImageData);
    console.log('listener added');

    document.querySelector('.cpb-upload-buttons-wrapper').addEventListener('click', () => {
      customCanvas.updateImageData(rightimageData);
    });
  });

  document.body.addEventListener('CPB_ON_UPDATE_CURRENT_VIEW', function(event) {
    if (!rightimageData || event.detail.currentView !== 'left') return
    customCanvas.updateImageData(rightimageData);
  });
  
}


document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
  customAddToCart();
  blockMovingLayerOnBox();
})































